const styleElement = document.createElement("dom-module");

styleElement.innerHTML = `<template>
  <style>
    .container-main {
      list-style: none;
      border-width: 2px;
      border-style: solid;
      border-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #D9D9D9) 0 0 0 1;
      margin: 0 0 0 1em;
      margin-block-start: 0px;
      margin-block-end: 0px;
      margin-inline-start: 10px;
      margin-inline-end: 0px;
      padding-inline-start: 12px;
    }
    .container {
      position: relative;
      margin-top: 8px;
    }
    .container:before {
      position: absolute;
      content: "";
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #D9D9D9;
      left: -16px;
      top: .3em;
    }
    .container .text-module {
      font-weight: 400;
      font-size: 14px;
      color: #424242;
      margin-left: 10px;
    }
    p {
      display: block;
      margin-block-start: 0;
      margin-block-end: 0;
    }
    .content .text-description {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #424242;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3; /* number of lines to show */
      -webkit-box-orient: vertical;
    }
    .module-header {
      display: flex;
    }
    .container-is-passed {
      position: absolute;
      border-left: 2px solid #559808;
      height: 104%;
      top: 9px;
      left: 3.6px;
    }
    .container-is-failed {
      position: absolute;
      height: 104%;
      top: 9px;
      border-left: 2px solid #D0021B;
      left: 3.6px;
    }
    .container-is-default {
      position: absolute;
      height: 104%;
      top: 9px;
      border-left: 2px solid #D9D9D9;
      left: 3.6px;
    }
    .container-is-default-not-registered {
      position: absolute;
      height: 106%;
      top: 9px;
      border-left: 2px solid #D9D9D9;
      left: 3.6px;
    }
  </style>
 </template>`;

styleElement.register("ecourse-list-topik-style");
